import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Progress,
  Badge,
  FormGroup,
  Input,
  Label
} from "reactstrap";
import {
  Clock,
  HelpCircle,
  CheckCircle
} from "react-feather";
import img from "../public/image.png"

const QuestionCard = ({
  question,
  selectedOption,
  setSelectedOption,
  remainingTime,
  onSubmit
}) => {

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const totalTime = question.duration || 30;

  const progress =
    (remainingTime / totalTime) * 100;

  return (
    <Card className="border-0 shadow-sm">

      <CardBody>

        {/* Header */}

        <Row className="align-items-center">

          <Col md="10">

            <div>
              <Badge color="primary" pill className="mb-2">

                Question {question.sequence} of {question.totalQuestions}

              </Badge>

              <h4 className="fw-bold">

                <HelpCircle
                  size={20}
                  className="me-2 text-primary"
                />

                {question.question}

              </h4>
            </div>
            <div>
              <img src={img} alt="" width={500} height={250}/>
            </div>

          </Col>

          <Col md="12" className="text-md-end mt-3 mt-md-0">

            <Badge
              color={
                remainingTime <= 10
                  ? "danger"
                  : "success"
              }
              className="px-3 py-2 fs-6"
            >

              <Clock size={16} className="me-1" />

              {formatTime(remainingTime)}

            </Badge>

          </Col>

        </Row>

        {/* Progress */}

        <Progress
          animated
          striped
          color={
            remainingTime <= 10
              ? "danger"
              : "primary"
          }
          value={progress}
          className="mt-4 mb-4"
          style={{ height: "10px" }}
        />

        {/* Options */}

        {question.options.map((option, index) => (

          <Card
            key={index}
            className={`mb-3 shadow-sm ${selectedOption === option.value
                ? "border border-primary"
                : ""
              }`}
          >

            <CardBody>

              <FormGroup check>

                <Input
                  type="radio"
                  id={option.value}
                  name="answer"
                  checked={
                    selectedOption === option.value
                  }
                  onChange={() =>
                    setSelectedOption(option.value)
                  }
                />

                <Label
                  check
                  htmlFor={option.value}
                  className="ms-2 w-100"
                  style={{
                    cursor: "pointer"
                  }}
                >

                  <strong>

                    {String.fromCharCode(65 + index)}.

                  </strong>

                  {" "}

                  {option.label}

                </Label>

              </FormGroup>

            </CardBody>

          </Card>

        ))}

        {/* Submit */}

        <div className="text-center mt-4">

          <Button
            color="success"
            size="lg"
            onClick={onSubmit}
            disabled={!selectedOption}
          >

            <CheckCircle
              size={18}
              className="me-2"
            />

            Submit Answer

          </Button>

        </div>

      </CardBody>

    </Card>
  );
};

export default QuestionCard;